import Router from "../Router";
import { GuidedTourProvider } from "../components/Tour";
import { SetupWizardProvider } from "../components/SetupWizard";
import { ThemeProvider } from "@mui/private-theming";
import { Theme } from "../theme";
import { SnackbarProvider } from "notistack";
import { AUTO_HIDE_DURATION, SNACKBAR_CONFIG } from "../utils/constants";
import {
  SNACKBAR_ERROR_ICON,
  SNACKBAR_SUCCESS_ICON,
} from "../utils/constants/assets";
import { SnackbarIcon } from "../components/Snackbar";
import { styles } from "./styles";
import { useLocation } from "react-router-dom";
import React from "react";
import { paginationDataAction } from "../redux/actions/customTableActions";
import { useDispatch } from "react-redux";
import * as qs from "qs";
import CreditWarningController from "../components/CreditWarningController";
import { WARNING } from "../utils/constants/colors";

// Inline so it ships with the bundle: the asset bucket has success/error icons only.
const SnackbarWarningIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: "10px", flexShrink: 0 }}
    aria-hidden="true"
  >
    <path
      d="M12 3.2 1.9 20.4h20.2L12 3.2Z"
      fill={WARNING.W_100}
      stroke={WARNING.W_500}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M12 9.2v5"
      stroke={WARNING.W_700}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="12" cy="17.2" r="1.05" fill={WARNING.W_700} />
  </svg>
);

export const Container = () => {
  const location = useLocation();
  const theme = Theme();
  const classes = styles();
  const dispatch = useDispatch();

  const res = qs.parse(window.location?.search?.slice(1));

  React.useEffect(() => {
    // This function execution is for dispatching location based events.
    (() => {
      dispatch(
        paginationDataAction({
          checkedRow: [],
          query: {},
        }),
      );
    })();
  }, [location.pathname]);

  React.useEffect(() => {
    // This function execution is for dispatching location based events.
    (() => {
      const query = {};
      if (res?.page) {
        query.page = parseInt(res?.page || 1);
      }

      if (res?.limit) {
        query.limit = parseInt(res?.limit || 10);
      }

      if (res?.sort) {
        query.sort = res?.sort
          ? { id: res?.sort, direction: res?.direction }
          : {};
      }

      dispatch(
        paginationDataAction({
          checkedRow: [],
          query: query,
        }),
      );
    })();
  }, []);

  // Cron for testing styles.

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        classes={{
          variantError: classes.error,
          variantSuccess: classes.success,
          variantWarning: classes.warning,
        }}
        maxSnack={1}
        anchorOrigin={SNACKBAR_CONFIG.snackBarPlacement}
        autoHideDuration={AUTO_HIDE_DURATION}
        iconVariant={{
          success: <SnackbarIcon src={SNACKBAR_SUCCESS_ICON} />,
          error: <SnackbarIcon src={SNACKBAR_ERROR_ICON} />,
          // Warning had no branded icon, so notistack fell back to its own default
          // and the toast read as a stock MUI alert next to the themed success/error
          // ones. Drawn inline in the palette's warning colour — there is no
          // snackbar_warning_icon.svg in the asset bucket to point at.
          warning: <SnackbarWarningIcon />,
        }}
      >
        <GuidedTourProvider>
          <SetupWizardProvider>
            <Router />
          </SetupWizardProvider>
        </GuidedTourProvider>
        <CreditWarningController />
      </SnackbarProvider>
    </ThemeProvider>
  );
};
